// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"user_wrapper__2ujEB","addUserButton":"user_addUserButton__3p45f"};